import axiosInstance from './apiClient'
import {
  DocumentRAGSettings,
  MyFile,
  ReprocessDocumentsResponse,
} from '@/redux/types/configuration'

export interface RoomAdvisorConfig {
  id: number
  room: string
  prompt: string | null
  metadata: string | null
  greetings: string | null
  scenario: string | null
  restrictions: string | null
  currency_cost?: number | null
  files: MyFile[]
  document_settings: Array<{
    id: number
    document_id: number
    use_full_context: boolean
    rag_enabled: boolean | null
    rag_chunk_size: number | null
    rag_chunk_overlap: number | null
  }> | null
}

export interface RoomAdvisorConfigPayload {
  prompt?: string
  metadata?: string
  greetings?: string
  scenario?: string
  restrictions?: string
  currency_cost?: number | null
  file_ids?: number[]
  document_settings_data?: Record<number | string, DocumentRAGSettings>
}

export const fetchRoomAdvisorConfig = async (
  roomId: string
): Promise<RoomAdvisorConfig | null> => {
  try {
    const response = await axiosInstance.get<RoomAdvisorConfig>(
      `/oge/rooms/${roomId}/advisor-config/`
    )
    return response.data
  } catch (error: any) {
    if (error?.response?.status === 404) {
      return null
    }
    throw error
  }
}

export const saveRoomAdvisorConfig = async (
  roomId: string,
  payload: RoomAdvisorConfigPayload
): Promise<RoomAdvisorConfig> => {
  const response = await axiosInstance.put<RoomAdvisorConfig>(
    `/oge/rooms/${roomId}/advisor-config/`,
    payload
  )
  return response.data
}

export const reprocessRoomDocuments = async (
  roomId: string,
  documentIds?: number[]
): Promise<ReprocessDocumentsResponse> => {
  const payload: { document_ids?: number[] } = {}
  if (documentIds !== undefined) {
    payload.document_ids = documentIds
  }
  const response = await axiosInstance.post<ReprocessDocumentsResponse>(
    `/oge/rooms/${roomId}/advisor-config/reprocess-documents/`,
    payload
  )
  return response.data
}
